import PurposeOfRemittance from "../../../types/purposeOfRemittance.type";
import React from "react";

export const purposeOfRemittanceItemNames: Record<PurposeOfRemittance, string> =
  {
    [PurposeOfRemittance.COMPUTER_SERVICES]: "Computer service",
    [PurposeOfRemittance.MAINTENANCE_EXPENSES]: "Maintenance or other expenses",
    [PurposeOfRemittance.SMALL_VALUE_REMITTANCE]: "Small value remittance",
    [PurposeOfRemittance.LIBERALIZED_REMITTANCE]: "Liberalized remittance",
    [PurposeOfRemittance.CONSTRUCTION_EXPENSES]: "Construction expenses",
    [PurposeOfRemittance.HOTEL_ACCOMMODATION]: "Hotel accommodation",
    [PurposeOfRemittance.ADVERTISING_EXPENSES]:
      "Advertising and/or public relations related expenses",
    [PurposeOfRemittance.ADVISORY_FEES]:
      "Fees for advisory or consulting service",
    [PurposeOfRemittance.BUSINESS_INSURANCE]:
      "Business related insurance payment",
    [PurposeOfRemittance.INSURANCE_CLAIMS]: "Insurance claims payment",
    [PurposeOfRemittance.DELIVERY_FEES]: "Delivery fees",
    [PurposeOfRemittance.EXPORTED_GOODS]: "Payments for exported goods",
    [PurposeOfRemittance.SERVICE_CHARGES]: "Payment for services",
    [PurposeOfRemittance.LOAN_PAYMENT]: "Payment of loans",
    [PurposeOfRemittance.OFFICE_EXPENSES]: "Office expenses",
    [PurposeOfRemittance.PROPERTY_PURCHASE]: "Residential property purchase",
    [PurposeOfRemittance.PROPERTY_RENTAL]: "Property rental payment",
    [PurposeOfRemittance.ROYALTY_FEES]:
      "Royalty, trademark, patent and copyright fees",
    [PurposeOfRemittance.SHARES_INVESTMENT]: "Investment in shares",
    [PurposeOfRemittance.FUND_INVESTMENT]: "Fund investment",
    [PurposeOfRemittance.TAX_PAYMENT]: "Tax payment",
    [PurposeOfRemittance.TRANSPORTATION_FEES]: "Transportation fees",
    [PurposeOfRemittance.UTILITY_BILLS]: "Utility bills",
    [PurposeOfRemittance.PERSONAL_TRANSFER]: "Personal transfer",
    [PurposeOfRemittance.REWARD_PAYMENT]: "Payment of rewards",
    [PurposeOfRemittance.INFLUENCER_PAYMENT]: "Payment of Influencer",
    [PurposeOfRemittance.OTHER_FEES]:
      "Broker, commitment, guarantee and other fees",
    [PurposeOfRemittance.OTHER]: "Other purposes",
  };

export const purposeOfRemittanceItems = Object.values(PurposeOfRemittance);

export const getPurposeOfRemittanceOptionLabel = (
  purposeOfRemittance: PurposeOfRemittance
) => (
  <div style={{ marginTop: "0px" }}>
    {purposeOfRemittanceItemNames[purposeOfRemittance]}
  </div>
);

export const purposeOfRemittancePlaceholder = (
  <div style={{ marginTop: "3px" }}>Purpose of Remittance</div>
);

export const optionPurpostOfRemitter = [
  {
    value: PurposeOfRemittance.COMPUTER_SERVICES,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.COMPUTER_SERVICES],
  },
  {
    value: PurposeOfRemittance.MAINTENANCE_EXPENSES,
    label:
      purposeOfRemittanceItemNames[PurposeOfRemittance.MAINTENANCE_EXPENSES],
  },
  {
    value: PurposeOfRemittance.SMALL_VALUE_REMITTANCE,
    label:
      purposeOfRemittanceItemNames[PurposeOfRemittance.SMALL_VALUE_REMITTANCE],
  },
  {
    value: PurposeOfRemittance.LIBERALIZED_REMITTANCE,
    label:
      purposeOfRemittanceItemNames[PurposeOfRemittance.LIBERALIZED_REMITTANCE],
  },
  {
    value: PurposeOfRemittance.CONSTRUCTION_EXPENSES,
    label:
      purposeOfRemittanceItemNames[PurposeOfRemittance.CONSTRUCTION_EXPENSES],
  },
  {
    value: PurposeOfRemittance.HOTEL_ACCOMMODATION,
    label:
      purposeOfRemittanceItemNames[PurposeOfRemittance.HOTEL_ACCOMMODATION],
  },
  {
    value: PurposeOfRemittance.ADVERTISING_EXPENSES,
    label:
      purposeOfRemittanceItemNames[PurposeOfRemittance.ADVERTISING_EXPENSES],
  },
  {
    value: PurposeOfRemittance.ADVISORY_FEES,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.ADVISORY_FEES],
  },
  {
    value: PurposeOfRemittance.BUSINESS_INSURANCE,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.BUSINESS_INSURANCE],
  },
  {
    value: PurposeOfRemittance.INSURANCE_CLAIMS,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.INSURANCE_CLAIMS],
  },
  {
    value: PurposeOfRemittance.DELIVERY_FEES,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.DELIVERY_FEES],
  },
  {
    value: PurposeOfRemittance.EXPORTED_GOODS,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.EXPORTED_GOODS],
  },
  {
    value: PurposeOfRemittance.SERVICE_CHARGES,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.SERVICE_CHARGES],
  },
  {
    value: PurposeOfRemittance.LOAN_PAYMENT,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.LOAN_PAYMENT],
  },
  {
    value: PurposeOfRemittance.OFFICE_EXPENSES,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.OFFICE_EXPENSES],
  },
  {
    value: PurposeOfRemittance.PROPERTY_PURCHASE,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.PROPERTY_PURCHASE],
  },
  {
    value: PurposeOfRemittance.PROPERTY_RENTAL,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.PROPERTY_RENTAL],
  },
  {
    value: PurposeOfRemittance.ROYALTY_FEES,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.ROYALTY_FEES],
  },
  {
    value: PurposeOfRemittance.SHARES_INVESTMENT,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.SHARES_INVESTMENT],
  },
  {
    value: PurposeOfRemittance.FUND_INVESTMENT,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.FUND_INVESTMENT],
  },
  {
    value: PurposeOfRemittance.TAX_PAYMENT,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.TAX_PAYMENT],
  },
  {
    value: PurposeOfRemittance.TRANSPORTATION_FEES,
    label:
      purposeOfRemittanceItemNames[PurposeOfRemittance.TRANSPORTATION_FEES],
  },
  {
    value: PurposeOfRemittance.UTILITY_BILLS,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.UTILITY_BILLS],
  },
  {
    value: PurposeOfRemittance.PERSONAL_TRANSFER,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.PERSONAL_TRANSFER],
  },
  {
    value: PurposeOfRemittance.REWARD_PAYMENT,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.REWARD_PAYMENT],
  },
  {
    value: PurposeOfRemittance.INFLUENCER_PAYMENT,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.INFLUENCER_PAYMENT],
  },
  {
    value: PurposeOfRemittance.OTHER_FEES,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.OTHER_FEES],
  },
  {
    value: PurposeOfRemittance.OTHER,
    label: purposeOfRemittanceItemNames[PurposeOfRemittance.OTHER],
  },
];
